/*
 * @Copyright: 中国信息安全测评中心
 * @Author: xiaowenwen
 * @Date: 2021-03-02 11:50:32
 * @LastEditTime: 2021-06-10 17:24:46
 * @Description:
 */

const PERM = {
  Web: 1,
  Flashmail: 2,
  Yixin: 4,
  Pop: 8,
  Imap: 16,
  Smtp: 32,
  AddrRight: 64,
  AddrVisible: 128,
  BigAttachment: 256,
  IsArchive: 512,
  ReceiveLimit: 1024,
  SendLimit: 2048,
  ResetpassGeneral: 4096,
  ResetpassMobile: 8192,
  Dashi: 16384,
  Activesync: 32768,
  Sirius: 65536,
  IsBindPhone: 131072,
  SecondaryLogon: 262144
};

export default PERM;
